"use strict";

var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");
var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/filter");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _chainFunction = _interopRequireDefault(require("chain-function"));
var _bind = _interopRequireDefault(require("classnames/bind"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _AddChildPropsContext = require("../utils/_AddChildPropsContext");
var _Icon = _interopRequireDefault(require("../Icon/Icon"));
var _constants = require("../utils/constants");
var _messages = require("../utils/messages");
var _keycode = _interopRequireDefault(require("../keycode/keycode"));
var _MultiComboBoxToken = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./MultiComboBoxToken.css") : void 0);
var _excluded = ["closeLabel", "className", "children", "closeClassName", "closeProps", "disabled", "onKeyDown", "onClick", "readOnly", "removeClassName", "removeLabel", "removeProps", "size", "selected", "overflow", "textClassName", "textProps", "validationMessageState"];
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
var CSS_BLOCK = 'sapcnqr-multicombobox-token';

/**
 * A Token may be used to represent contextualizing information.
 * For example, they can be useful to show applied filters,
 * selected values for form field, or object metadata.
 */
var MultiComboBoxToken = /*#__PURE__*/_react.default.forwardRef(function (_props, ref) {
  var _context, _context2;
  var addChildProps = (0, _AddChildPropsContext.useAddChildProps)();
  var props = addChildProps ? _objectSpread(_objectSpread({}, _props), addChildProps(MultiComboBoxToken, _props)) : _props;
  var closeLabel = props.closeLabel,
    className = props.className,
    children = props.children,
    closeClassName = props.closeClassName,
    closeProps = props.closeProps,
    disabled = props.disabled,
    onKeyDown = props.onKeyDown,
    onClick = props.onClick,
    readOnly = props.readOnly,
    removeClassName = props.removeClassName,
    removeLabel = props.removeLabel,
    removeProps = props.removeProps,
    _props$size = props.size,
    size = _props$size === void 0 ? 'lg' : _props$size,
    selected = props.selected,
    overflow = props.overflow,
    textClassName = props.textClassName,
    textProps = props.textProps,
    validationMessageState = props.validationMessageState,
    otherProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var classnames = _bind.default.bind(_MultiComboBoxToken.default);
  var handleOnClick = function handleOnClick(e) {
    if (disabled) {
      e.preventDefault();
      e.stopPropagation();
    } else {
      onClick === null || onClick === void 0 || onClick(e);
    }
  };
  var handleKeyDown = function handleKeyDown(e) {
    switch (e.keyCode) {
      case _keycode.default.codes.enter:
        handleOnClick(e);
        break;
      case _keycode.default.codes.space:
        e.preventDefault();
        handleOnClick(e);
        break;
      default:
        break;
    }
  };
  var classes = classnames(CSS_BLOCK, (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, (0, _concat.default)(_context = "".concat(CSS_BLOCK, "--")).call(_context, size), size !== 'lg'), "".concat(CSS_BLOCK, "--selected"), selected), "".concat(CSS_BLOCK, "--readonly"), readOnly), "".concat(CSS_BLOCK, "--disabled"), disabled), "".concat(CSS_BLOCK, "--overflow"), overflow), (0, _concat.default)(_context2 = "".concat(CSS_BLOCK, "--")).call(_context2, validationMessageState), overflow && validationMessageState), className);
  var textClasses = classnames("".concat(CSS_BLOCK, "__text"), textClassName, textProps === null || textProps === void 0 ? void 0 : textProps.className);
  var iconClasses = classnames("".concat(CSS_BLOCK, "__close"), removeClassName || closeClassName, (removeProps === null || removeProps === void 0 ? void 0 : removeProps.className) || (closeProps === null || closeProps === void 0 ? void 0 : closeProps.className));
  var iconSizes = {
    lg: 'xs-plus',
    md: 'xs'
  };
  return /*#__PURE__*/_react.default.createElement("span", (0, _extends2.default)({
    role: "button",
    tabIndex: disabled ? -1 : 0
  }, otherProps, {
    className: classes,
    disabled: disabled,
    onClick: handleOnClick,
    onFocus: function onFocus(e) {
      if (disabled) {
        var _e$target;
        (_e$target = e.target) === null || _e$target === void 0 || _e$target.blur();
      }
    },
    onKeyDown: (0, _chainFunction.default)(handleKeyDown, onKeyDown),
    ref: ref
  }), /*#__PURE__*/_react.default.createElement("span", (0, _extends2.default)({}, textProps, {
    className: textClasses
  }), children), !readOnly && !overflow && /*#__PURE__*/_react.default.createElement("span", (0, _extends2.default)({}, removeProps || closeProps, {
    className: iconClasses,
    role: "presentation"
  }), /*#__PURE__*/_react.default.createElement(_Icon.default, {
    ariaLabel: removeLabel || closeLabel,
    iconName: "close",
    size: iconSizes[size]
  })));
});
MultiComboBoxToken.displayName = 'MultiComboBoxToken';
MultiComboBoxToken.propTypes = {
  /** The content of the Token */
  children: _propTypes.default.node.isRequired,
  /** Additional class(es) added to the wrapping span element */
  className: _propTypes.default.string,
  /** @deprecated Additional class(es) added to the close span */
  closeClassName: _propTypes.default.string,
  /** @deprecated Accessibility label for the close icon */
  closeLabel: _propTypes.default.string,
  /** @deprecated Additional props spread to the span which wraps the close icon */
  closeProps: _propTypes.default.object,
  /** Set to `true` to disable the **Token**. */
  disabled: _propTypes.default.bool,
  /** Set to `true` to set the **Token** to readOnly */
  readOnly: _propTypes.default.bool,
  /** Additional class(es) added to the remove span */
  removeClassName: _propTypes.default.string,
  /** Accessibility label for the remove icon */
  // eslint-disable-next-line consistent-return
  removeLabel: function removeLabel(props, propName, componentName) {
    if (!props.readOnly && !props.overflow && (!props[propName] || typeof props[propName] !== 'string')) {
      var _context3, _context4;
      return new Error((0, _concat.default)(_context3 = (0, _concat.default)(_context4 = "The prop `".concat(propName, "` is required in `")).call(_context4, componentName, "` when `readOnly` is not true. ")).call(_context3, (0, _messages.LOCALIZED_TEXT_MESSAGE)('CoreUIComponents.remove')));
    }
  },
  /** Additional props spread to the span which wraps the remove icon */
  removeProps: _propTypes.default.object,
  /** Apply overflow type styles */
  overflow: _propTypes.default.bool,
  /** Modifies the color of the token to differentiate it as selected */
  selected: _propTypes.default.bool,
  /** The size of the Token 'lg' or 'md' */
  size: _propTypes.default.oneOf(_constants.CONTROL_SIZES),
  /** Additional class(es) added to the text span element */
  textClassName: _propTypes.default.string,
  /** Additional props spread to the text span */
  textProps: _propTypes.default.object,
  /** @ignore - set by **Tokenizer** */
  validationMessageState: _propTypes.default.string,
  /** Callback for when the **Token** is clicked */
  onClick: _propTypes.default.func,
  /** Callback for when the **Token** is clicked via keyboard */
  onKeyDown: _propTypes.default.func
};
var _default = exports.default = MultiComboBoxToken;